module.exports = {"331022001":"海游街道","331022002":"海润街道","331022003":"沙柳街道","331022102":"珠岙镇","331022103":"亭旁镇","331022105":"健跳镇","331022106":"横渡镇","331022107":"浦坝港镇","331022108":"花桥镇","331022205":"蛇蟠乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/331022.json
// module id = 1123
// module chunks = 0